import React from "react";

import { getAccountWithAllCompanyProfiles } from "EntitiesApi/api";
import { Provider } from "react-redux";

import { receiveAccountData } from "./actions";
import createStore from "./store";
import SwitchCompany from "./SwitchCompany";

import type { State, Action } from "./store";
import type { Store } from "redux";

type Props = {};

class App extends React.Component<Props> {
  store: Store<State, Action>;

  constructor() {
    super();
    this.store = createStore({
      accountId: "",
    });
  }

  componentDidMount() {
    this.store.dispatch(
      getAccountWithAllCompanyProfiles({
        onSuccess: (response, dispatch, _request) => {
          dispatch(receiveAccountData(response));
        },
      }),
    );
  }

  render() {
    return (
      <Provider store={this.store}>
        <SwitchCompany />
      </Provider>
    );
  }
}

export default App;
